import type { UserPreferencesNotificationsSwitchProps } from "./user-preferences-notifications-switch.type";

export const useUserPreferencesNotificationsSwitch = ({
  channel,
  notificationKey,
  defaultChannels,
  userPreferencesNotifications,
  onNotificationSettingsChange,
}: UserPreferencesNotificationsSwitchProps) => {
  const defaultChannel =
    defaultChannels.find((c) => c.name === channel)?.default || false;
  const userPreference = userPreferencesNotifications?.[notificationKey];
  const isChecked = userPreference ? userPreference[channel] : defaultChannel;

  const handleChange = (checked: boolean) => {
    if (!userPreferencesNotifications || !userPreference) return;
    const newUserPreferencesNotifications = {
      ...userPreferencesNotifications,
      [notificationKey]: {
        ...userPreference,
        [channel]: checked,
      },
    };
    onNotificationSettingsChange(newUserPreferencesNotifications);
  };
  return { handleChange, isChecked };
};
